module.exports = __webpack_public_path__ + "img/ic_hj_mode_sleepaid.38d3da81.png";